export default {
  changePeople: (state) => {
   
  }
}



// WEBPACK FOOTER //
// ./src/Vuex/getters.js